import saleConfigJson from "./sale-config.json";

export const saleConfig = saleConfigJson;

export type SaleComponentId = keyof typeof saleConfig.components;

export function isSaleEnabled(component: SaleComponentId): boolean {
  if (!saleConfig.enabled) return false;
  return saleConfig.components[component].enabled === true;
}

export function getSaleComponent<K extends SaleComponentId>(
  component: K,
): (typeof saleConfig.components)[K] | undefined {
  if (!isSaleEnabled(component)) return undefined;
  return saleConfig.components[component];
}

export function getHeroBadgeText(fallback = "Launch offer") {
  if (!saleConfig.enabled) return fallback;
  return saleConfig.components.hero?.badgeText ?? "Flash Sale";
}

export function getOfferStripCopy() {
  const productHero = saleConfig.components.productHero;
  return {
    label: productHero?.offerStripLabel ?? "Flash Sale",
    percent: productHero?.offerStripPercent ?? 35,
  };
}
